<template>
    <CardShell>
        <div class="pv3 ph3 bg-near-white bb b--light-gray">
            <h5 class="mt1">Rate<span v-if="combinedRates.length > 1">s</span>
            </h5>
        </div>
        <PricingItem v-for="(rate, index) in combinedRates" :key="index" :rate="rate.rate" :hours="rate.hours" />
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import PricingItem from '@/components/rent/listingDetail/pricingCard/PricingItem.vue';
import UnderlinedHeading from '@/components/controls/UnderlinedHeading.vue';

export default {
    components: {
        CardShell,
        UnderlinedHeading,
        PricingItem
    },
    props: {
        dailyRate: {
            type: Number
        },
        rates: {
            type: Array
        }
    },
    computed: {
        combinedRates() {
            var combined = this.rates.concat([
                { hours: 24, rate: this.dailyRate }
            ]);
            combined.sort((a, b) => a.hours - b.hours);
            return combined;
        }
    }
};
</script>
